import jwtAxios from "@crema/services/auth/jwt-auth";
import {
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    GET_ALL_ASHRAMWASI_USERS,
    ADD_USER,
    UPDATE_USER,
    UPDATE_USER_STATUS,
    GET_ALL_DEPARTMENTS,
    CREATE_DEPARTMENT,
    UPDATE_DEPARTMENT,
    GET_ISSUE_CATEGORY,
    UPDATE_ISSUE_CATEGORY,
    DELETE_ISSUE_CATEGORY,
    CREATE_ISSUE_CATEGORY,
    GET_ROOM_LOCATION,
    CREATE_ROOM_LOCATION,
    UPDATE_ROOM_LOCATION,
    DELETE_ROOM_LOCATION,
    GET_SOS_LIST,
    // VERIFY_USER,
    SHOW_MESSAGE,
} from "shared/constants/ActionTypes";
import { HTTP_STATUS } from "shared/constants/AppConst";

// USER MANAGEMENT MASTER
export const getAllAshramwasi = () => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios

            .get("admin/get-all-users-roles")
            .then((res) => {
                if (res.data.httpStatus === "OK") {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({
                        type: GET_ALL_ASHRAMWASI_USERS,
                        payload: res.data.data,
                    });
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: res.data.message || "Something went Wrong",
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload:
                        error.response.data.message || "Something went Wrong",
                });
            });
    };
};
export const getAllAshramwasiUnique = () => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .get("admin/get-all-ashramwasi-roles")
            .then((res) => {
                if (res.data.httpStatus === "OK") {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({
                        type: GET_ALL_ASHRAMWASI_USERS,
                        payload: res.data.data,
                    });
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: res.data.message || "Something went Wrong",
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload:
                        error.response.data.message || "Something went Wrong",
                });
            });
    };
};
export const createAshramwasi = (data, setOpen) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .post(`admin/create-ashramwasi-users-roles`, data)
            .then((res) => {
                if (res.status === 200 && res.data.httpStatus == "OK") {
                    dispatch({
                        type: ADD_USER,
                        payload: res.data.data,
                    });
                    setOpen(false);
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({ type: SHOW_MESSAGE, payload: res.data.message });
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: res.data.message || "Something went Wrong",
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload: error.message || "Something went Wrong",
                });
            });
    };
};
export const updateAshramwasi = (data) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        return new Promise((resolve, reject) =>
            jwtAxios
                .post(`admin/update-all-users-roles`, data)
                .then((res) => {
                    if (res.status === 200 && res.data.httpStatus == "OK") {
                        dispatch({ type: FETCH_SUCCESS });
                        dispatch({
                            type: SHOW_MESSAGE,
                            payload: res.data.message,
                        });
                        dispatch({
                            type: UPDATE_USER,
                            payload: res.data.data,
                        });
                        return resolve(res.data);
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: res.data.message || "Something went Wrong",
                        });
                        return reject();
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: error.message || "Something went Wrong",
                    });
                    return reject(error);
                })
        );
    };
};
export const updateAshramwasiStatus = (data) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        return new Promise((resolve, reject) =>
            jwtAxios
                .post(`admin/update-user-status`, null, {
                    params: {
                        userCode: data.userCode,
                        flag: !data.status,
                        role: data.roleType,
                    },
                })
                .then((res) => {
                    if (res.status === 200 && res.data.httpStatus == "OK") {
                        dispatch({ type: FETCH_SUCCESS });
                        dispatch({
                            type: SHOW_MESSAGE,
                            payload: res.data.message,
                        });
                        dispatch({
                            type: UPDATE_USER_STATUS,
                            payload: res.data.data,
                        });
                        return resolve(res.data);
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: res.data.message || "Something went Wrong",
                        });
                        return reject();
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: error.message || "Something went Wrong",
                    });
                    return reject(error);
                })
        );
    };
};

// DEPARTMENT MASTER
export const getAllDepartments = (status = null) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .get(`admin/get-all-dept/${status}`)
            .then((res) => {
                if (res.data.httpStatus === HTTP_STATUS.OK) {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({
                        type: GET_ALL_DEPARTMENTS,
                        payload: res.data.data,
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload:
                        error.response.data.message || "Something went Wrong",
                });
            });
    };
};
export const createDepartment = (data, setOpen) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            // .post("admin/create-dept", data)
            .post("admin/create-dept", data)
            .then((res) => {
                if (res.data.httpStatus === "OK") {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({
                        type: CREATE_DEPARTMENT,
                        payload: res.data.data,
                    });
                    setOpen(false);
                    dispatch({ type: SHOW_MESSAGE, payload: res.data.message });
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: res.data.message || "Something went Wrong",
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload:
                        error.response.data.message || "Something went Wrong",
                });
            });
    };
};
export const updateDepartment = (id, data, setOpen) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .post(`admin/update-dept/${id}`, data)
            .then((res) => {
                if (res.status === 200 && res.data.httpStatus == "OK") {
                    dispatch({
                        type: UPDATE_DEPARTMENT,
                        payload: { data: res.data.data, id: id },
                    });
                    setOpen(false);
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({ type: SHOW_MESSAGE, payload: res.data.message });
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: res.data.message || "Something went Wrong",
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload:
                        error.response.data.message || "Something went Wrong",
                });
            });
    };
};
// ISSUE CATEGORY MASTER
export const createIssueCategory = (data, setOpen) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .post("admin/create-issue-category", data)
            .then((res) => {
                if (res.data.status == "200") {
                    dispatch({
                        type: CREATE_ISSUE_CATEGORY,
                        payload: res.data.data,
                    });
                    setOpen(false);
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({ type: SHOW_MESSAGE, payload: res.data.message });
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: res.data.message || "Something went Wrong",
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload:
                        error.response.data.message || "Something went Wrong",
                });
            });
    };
};
export const getAllIssueCategory = () => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .get("admin/get-issue-category")
            .then((res) => {
                dispatch({
                    type: GET_ISSUE_CATEGORY,
                    payload: res.data.data,
                });
                dispatch({ type: FETCH_SUCCESS });
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload:
                        error.response.data.message || "Something went Wrong",
                });
            });
    };
};
export const updateIssueCategory = (id, data, setOpen) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .post(`admin/update-issue-category/${id}`, data)
            .then((res) => {
                if (res.data.status == "200") {
                    dispatch({
                        type: UPDATE_ISSUE_CATEGORY,
                        payload: { data: res.data.data, id: id },
                    });
                    setOpen(false);
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({ type: SHOW_MESSAGE, payload: res.data.message });
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: res.data.message || "Something went Wrong",
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload:
                        error.response.data.message || "Something went Wrong",
                });
            });
    };
};
export const deleteIssueCategory = (id) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        return new Promise((resolve, reject) =>
            jwtAxios
                .post(`admin/delete-issue-category/${id}`)
                .then((res) => {
                    if (res.data.status === "200") {
                        dispatch({
                            type: DELETE_ISSUE_CATEGORY,
                            payload: {
                                id: id,
                            },
                        });
                        dispatch({ type: FETCH_SUCCESS });
                        dispatch({
                            type: SHOW_MESSAGE,
                            payload: res.data.message,
                        });
                        return resolve(res.data);
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: res.data.message || "Something went Wrong",
                        });
                        return reject();
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: FETCH_ERROR,
                        payload:
                            error.response.data.message ||
                            "Something went Wrong",
                    });
                    return reject(error);
                })
        );
    };
};

// LOCATION AUTHORITIES MASTER
export const getAllLocationAuthorities = () => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .get("admin/get-all-loc-authorities")
            .then((res) => {
                dispatch({
                    type: GET_ROOM_LOCATION,
                    payload: res.data.data,
                });
                dispatch({ type: FETCH_SUCCESS });
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload:
                        error.response.data.message || "Something went Wrong",
                });
            });
    };
};
export const createLocationAuthorities = (data, setOpen) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .post("admin/create-loc-authorities", data)
            .then((res) => {
                if (res.data.status == "200") {
                    dispatch({
                        type: CREATE_ROOM_LOCATION,
                        payload: res.data.data,
                    });
                    setOpen(false);
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({ type: SHOW_MESSAGE, payload: res.data.message });
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: res.data.message || "Something went Wrong",
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload:
                        error.response.data.message || "Something went Wrong",
                });
            });
    };
};
export const updateLocationAuthorities = (id, data, setOpen) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .post(`admin/update-loc-authorities/${id}`, data)
            .then((res) => {
                if (res.data.status == "200") {
                    dispatch({
                        type: UPDATE_ROOM_LOCATION,
                        payload: { data: res.data.data, id },
                    });
                    setOpen(false);
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({ type: SHOW_MESSAGE, payload: res.data.message });
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: res.data.message || "Something went Wrong",
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload:
                        error.response.data.message || "Something went Wrong",
                });
            });
    };
};
export const deleteLocationAuthorities = (id) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        return new Promise((resolve, reject) =>
            jwtAxios
                .post(`admin/delete-loc-authorities/${id}`)
                .then((res) => {
                    if (res.data.status === "200") {
                        dispatch({
                            type: DELETE_ROOM_LOCATION,
                            payload: {
                                id: id,
                            },
                        });
                        dispatch({ type: FETCH_SUCCESS });
                        dispatch({
                            type: SHOW_MESSAGE,
                            payload: res.data.message,
                        });
                        return resolve(res.data);
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: res.data.message || "Something went Wrong",
                        });
                        return reject();
                    }
                })
                .catch((error) => {
                    dispatch({
                        type: FETCH_ERROR,
                        payload:
                            error.response.data.message ||
                            "Something went Wrong",
                    });
                    return reject(error);
                })
        );
    };
};

// SOS

export const createSOSRequest = (data) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .post(`roombooking/create-sos-details`, data)
            .then((res) => {
                if (res.status == "200") {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({ type: SHOW_MESSAGE, payload: res.data.message });
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: res.data.message || "Something went Wrong",
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload: error.message || "Something went Wrong",
                });
            });
    };
};
export const getSOSRequestDetails = (data) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        jwtAxios
            .get(`roombooking/get-all-sosDetails`, data)
            .then((res) => {
                if (res.status == "200") {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({ type: GET_SOS_LIST, payload: res.data });
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: res.data.message || "Something went Wrong",
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_ERROR,
                    payload: error.message || "Something went Wrong",
                });
            });
    };
};
